export const openScottie = (message) => window.dispatchEvent(new CustomEvent("scottie:open", { detail: { message } }));
export const selectLesson = (title) => window.dispatchEvent(new CustomEvent("c2c:lesson", { detail: { title } }));
